<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nom</label>
      </div>
      <input v-model="dataForm.nom"
             class="form-control"
             name="equipe_nom"
             placeholder="Entrez le nom de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Slogan</label>
      </div>
      <input v-model="dataForm.slogan"
             class="form-control"
             name="equipe_slogan"
             placeholder="Entrez le slogan de l'équipe"
             type="text"
      >
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Date de création de l'équipe</label>
      </div>
      <input v-model="dataForm.date_creation_equipe"
             class="form-control"
             name="equipe_date_creation_equipe"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Championnat</label>
      </div>
      <select v-model="dataForm.championnat_id"
              class="custom-select"
              name="equipe_championnat">
        <option :value="equipe.championnat_id">
          {{ championnats ?
            (championnats.filter((championnat) => championnat.championnat_id === equipe.championnat_id)[0].nom) :
            'Choisissez un championnat...' }}
        </option>
        <option :value="equipe.championnat_id" value="">-------------------------------------</option>

        <option :value="championnat.championnat_id"
                :key="championnat.championnat_id.slice(5,15)"
                v-for="championnat in championnats">{{ championnat.nom }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Totem</label>
      </div>
      <input v-model="dataForm.totem"
             class="form-control"
             name="equipe_totem"
             placeholder="Entrez le totem de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Logo</label>
      </div>
      <input ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Historique</label>
      </div>
      <textarea v-model="dataForm.historique"
                class="form-control"
                name="equipe_historique"
                placeholder="Entrez l'historique' de l'équipe"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Noms du président</label>
      </div>
      <input v-model="dataForm.nom_complet_president"
             class="form-control"
             name="equipe_nom_complet_president"
             placeholder="Entrez le nom complet du président de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Téléphones du président</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.telephones_president"
             class="form-control"
             name="equipe_president_telephone_1"
             placeholder="Entrez le numéro prncipal du président"
             type="tel">
      <input v-model="dataForm.telephones_president"
             class="form-control"
             name="equipe_president_telephone_2"
             placeholder="Entrez le numéro secondaire du président"
             type="tel">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Noms du serétaire</label>
      </div>
      <input v-model="dataForm.nom_complet_secretaire"
             class="form-control"
             name="equipe_nom_complet_secretaire"
             placeholder="Entrez le nom complet du secrétaire de l'équipe"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Téléphones du président</label>
        <label class="input-group-text"></label>
      </div>
      <input v-model="dataForm.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_1"
             placeholder="Entrez le numéro prncipal du secrétaire"
             type="tel">
      <input v-model="dataForm.telephones_secretaire"
             class="form-control"
             name="equipe_secretaire_telephone_2"
             placeholder="Entrez le numéro secondaire du secrétaire"
             type="tel">
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Update",
  props: {
    equipe: {
      type: Object
    }
  },
  data() {
    return {
      championnats: null,
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        slogan: '',
        date_creation_equipe: '',
        championnat_id: '',
        totem: '',
        logo: '',
        description: '',
        historique: '',
        commentaires: '',
        nom_complet_president: '',
        telephones_president: '',
        nom_complet_secretaire: '',
        telephones_secretaire: '',
        table: 'equipes',
        table_id: this.equipe.equipe_id,
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
      location.reload(false)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosPutData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFileAndSendData () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom){
        fileName = this.dataForm.nom.split(' ').join('').toLowerCase() + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "equipes")
      this.axiosPostFileData(formData)
          .then(data => {
            this.dataForm.logo = data[2];
            this.resetDefaultValues()
            if(!this.dataForm.logo)
              this.dataForm.logo = this.equipe.logo
            this.axiosPutData(this.dataForm)
                .then((data) => {
                  if(data.status === 204)
                    this.messageSuccess = "Equipe modifiée avec succès !"
                  else
                    this.messageFailure = "Une erreur est survenue lors de la modification de l'équipe !"
                })
                .catch((error) => {
                  this.messageFailure = "Une erreur est survenue lors de la modification  de l'équipe !"
                })
          })
          .catch(data => {
          })
    },
    onSubmit() {
      this.uploadFileAndSendData()
    },
    resetDefaultValues() {
      if(this.dataForm.nom === '')
        this.dataForm.nom = this.equipe.nom
      if(this.dataForm.slogan === '')
        this.dataForm.slogan = this.equipe.slogan
      if(this.dataForm.date_creation_equipe === '')
        this.dataForm.date_creation_equipe = this.equipe.date_creation_equipe
      if(this.dataForm.championnat_id === '')
        this.dataForm.championnat_id = this.equipe.championnat_id
      if(this.dataForm.totem === '')
        this.dataForm.totem = this.equipe.totem
      if(this.dataForm.historique === '')
        this.dataForm.historique = this.equipe.historique
      if(this.dataForm.nom_complet_president === '')
        this.dataForm.nom_complet_president = this.equipe.nom_complet_president
      if(this.dataForm.telephones_president === '')
        this.dataForm.telephones_president = this.equipe.telephones_president
      if(this.dataForm.nom_complet_secretaire === '')
        this.dataForm.nom_complet_secretaire = this.equipe.nom_complet_secretaire
      if(this.dataForm.telephones_secretaire === '')
        this.dataForm.telephones_secretaire = this.equipe.telephones_secretaire
    },
    setDefaultValues() {
      const equipe = Object.assign({}, this.equipe);
      this.dataForm.nom = equipe.nom
      this.dataForm.slogan = equipe.slogan
      this.dataForm.date_creation_equipe = equipe.date_creation_equipe
      this.dataForm.championnat_id = equipe.championnat_id
      this.dataForm.totem = equipe.totem
      this.dataForm.historique = equipe.historique
      this.dataForm.nom_complet_president = equipe.nom_complet_president
      this.dataForm.telephones_president = equipe.telephones_president
      this.dataForm.nom_complet_secretaire = equipe.nom_complet_secretaire
      this.dataForm.telephones_secretaire = equipe.telephones_secretaire
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {
  },
  created() {
    this.setDefaultValues()
    //
    this.axiosGetAllData({
      table: 'championnats'
    })
        .then((data) => {
          this.championnats = data.data
        })
        .catch((data) => {
          this.championnats = data
        })
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipes/components/Update.vue